export default {
  ActivityList: {
    Title: 'Hoạt động tài chính',
    DictionaryActivity: '/ Hoạt động tài chính',
    Dictionary: 'Danh mục',
  },
  ActivityDetail: {
    ActivityCode: 'Mã hoạt động *',
    ActivityName: 'Tên hoạt động *',
    ActivityCategoryName: 'Thuộc loại',
    Description: 'Diễn giải',
    Follow: 'Theo dõi',
  },
};
